import type { ReactElement, ReactNode } from 'react';
import { CheckField, DatePickerField, DateRangePickerField, TextField } from '@ff-it/form';
import { PayerVATCategoryField, PaymentDateField } from 'components';
import { CompanyField } from 'modules/core/company/components';

type InvoiceFieldsProps = {
  variant?: 'campaign' | 'bonus';
  poNumberField?: ReactNode;
};

function InvoiceOptions(): ReactElement {
  return (
    <div className="d-flex align-items-center" role="group" aria-label="Invoice options">
      <CheckField name="hide_issuer" fieldLabel="Hide issuer" variant="checkbox" inline />
    </div>
  );
}

export function InvoiceFields({ variant = 'campaign', poNumberField }: InvoiceFieldsProps): ReactElement {
  const isCampaign = variant === 'campaign';

  return (
    <>
      <div className="form-row">
        <CompanyField name="payer" label="Payer" required className="col-md-2" size="sm" includeBranches={true} />
        <DatePickerField name="checkout_date" label="Invoice date" className="col-md-1" size="sm" required />
        <PaymentDateField name="payment_date" label="Payment date" className="col-md-1" size="sm" required />
        <PayerVATCategoryField label="VAT category" className="col-md-2" size="sm" required />
        {isCampaign ? (
          <DateRangePickerField
            fromName="date_from"
            toName="date_to"
            className="col-md-2"
            size="sm"
            label="Service period"
            readOnly
          />
        ) : (
          <div className="form-group col-auto pt-4">
            <InvoiceOptions />
          </div>
        )}
      </div>
      {isCampaign && (
        <div className="form-row">
          <TextField
            name="campaign_title"
            placeholder="Campaign title"
            className="col-md-2"
            size="sm"
            help="Leave empty to use linked"
          />
          {poNumberField}
          <div className="form-group col-auto ml-3">
            <InvoiceOptions />
          </div>
        </div>
      )}
    </>
  );
}
